import styled from "styled-components";

export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: ${(props) => props.theme.layout.background};
  background-size:
    100% auto,
    cover; /* Разное масштабирование для каждого слоя */
  background-repeat: repeat-y, no-repeat; /* Повтор только для орнамента */
  background-position:
    top center,
    center;
  /* background-size: cover; */
  /* background-size: cover; */

  overflow: hidden;
`;

export const StyledMain = styled.main`
  flex-grow: 1;
  display: flex;
  width: auto; /*64.8125remШИРИНА ОБЛАСТИ КАЛЕНДАРЯ*/
  flex-direction: column;
  overflow: hidden;
  height: 0;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
